import { reactive } from "vue";

// Messages waiting to be shown by the app-wide <v-snackbar-queue> in App.vue.
export const notificationQueue = reactive({ messages: [] });

export function notify(text, color = "success", timeout = 4000) {
  notificationQueue.messages.push({ text, color, timeout });
}

export function notifyError(text) {
  notify(text, "error", 6000);
}

// Message with an extra button (e.g. "Annuler") that runs onAction before closing the message.
export function notifyWithAction(text, actionText, onAction, color = "success") {
  notificationQueue.messages.push({ text, color, timeout: 6000, actionText, onAction });
}
